import {Container} from "@pg-design/grid-module";
import {backgroundColor} from "@pg-design/helpers-css";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
}
export const PricesBreadcrumbs = (props: IProps) => {
    return (
        <div css={backgroundColor("#fff")}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />}>
                    <BreadcrumbsItem
                        isLinkingToCurrentLocation={!props.region}
                        name={`Ceny ${getWhichLabelFromPricesViewType(props.type)}`}
                        position="2"
                        url={rpAppLink.prices.flats.base()}
                    />
                    {props.region && (
                        <BreadcrumbsItem
                            isLinkingToCurrentLocation
                            name={`${props.region.short_name}`}
                            position="3"
                            url={rpAppLink.prices.flats.city({regionSlug: props.region.slug})}
                        />
                    )}
                </Breadcrumbs>
            </Container>
        </div>
    );
};
import {Container} from "@pg-design/grid-module";
import {backgroundColor} from "@pg-design/helpers-css";
import {HomeIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getWhichLabelFromPricesViewType, PricesViewType} from "../helpers/prices_view_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice | null;
}
export const PricesBreadcrumbs = (props: IProps) => {
    return (
        <div css={backgroundColor("#fff")}>
            <Container>
                <Breadcrumbs homePageUrl={rpAppLink.base()} homePageIcon={<HomeIcon size="1.4" />}>
                    <BreadcrumbsItem
                        isLinkingToCurrentLocation={!props.region}
                        name={`Ceny ${getWhichLabelFromPricesViewType(props.type)}`}
                        position="2"
                        url={rpAppLink.prices.flats.base()}
                    />
                    {props.region && (
                        <BreadcrumbsItem
                            isLinkingToCurrentLocation
                            name={`${props.region.short_name}`}
                            position="3"
                            url={rpAppLink.prices.flats.city({regionSlug: props.region.slug})}
                        />
                    )}
                </Breadcrumbs>
            </Container>
        </div>
    );
};
